import { Link, useLocation } from "react-router-dom";

const MobileMenuItem = ({ icon, text, link, type, setOpenMenu }) => {
  const location = useLocation();
  const { pathname } = location;

  return type === `menu` ? (
    <li className="list-group-item">
      {/*begin::Heading*/}
      <div className="menu-item">
        <div className="menu-content menu-heading text-uppercase fs-7">
          {text}
        </div>
      </div>
      {/*end::Heading*/}
    </li>
  ) : (
    <li
      className={
        pathname && pathname === link
          ? "list-group-item rounded-0 bg-primary text-light-500"
          : "list-group-item rounded-0"
      }
      onClick={() => setOpenMenu((prev) => !prev)}
    >
      {/*begin:Menu item*/}
      <Link to={link} className="d-flex flex-stack">
        {/*begin::Symbol*/}
        <button className="btn btn-sm btn-icon bg-gray-300 w-30px h-30px ms-3">
          {icon}
        </button>

        {/*end::Symbol*/}

        {/*begin::Section*/}
        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
          {/*begin:Author*/}
          <div className="flex-grow-1 mx-2">
            <span
              className={
                pathname && pathname === link
                  ? "fs-6 fw-bold text-light"
                  : "fs-6 fw-bold text-gray-600"
              }
            >
              {text}
            </span>
          </div>
          {/*end:Author*/}

          {/*begin::Actions*/}
          <button className="btn btn-sm btn-icon bg-gray-300 w-30px h-30px ms-3">
            <i className="ki-duotone ki-right fs-2x text-gray-500">
              <span className="path1"></span>
              <span className="path2"></span>
            </i>
          </button>
          {/*begin::Actions*/}
        </div>
        {/*end::Section*/}
      </Link>
      {/*end:Menu item*/}
    </li>
  );
};

export default MobileMenuItem;
